import { render } from "./singleEvent.vue?vue&type=template&id=c7a6a684&scoped=true"
import script from "./singleEvent.vue?vue&type=script&lang=js"
export * from "./singleEvent.vue?vue&type=script&lang=js"

import "./singleEvent.vue?vue&type=style&index=0&id=c7a6a684&lang=css"
import "./singleEvent.vue?vue&type=style&index=1&id=c7a6a684&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a6a684"]])

export default __exports__